import { render } from "./CheckCircle.vue?vue&type=template&id=2236645a"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/CheckCircle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2236645a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2236645a', __exports__)) {
    api.reload('2236645a', __exports__)
  }
  
  module.hot.accept("./CheckCircle.vue?vue&type=template&id=2236645a", () => {
    api.rerender('2236645a', render)
  })

}


export default __exports__